// بطاقة قسم مع أيقونة وعنوان — تُستخدم لكل قسم في صفحة تفاصيل الأمر.
export const DetailCard = ({ icon: Icon, title, action, tone = "primary", children, tid }) => {
  const toneCls = tone === "emerald" ? "text-emerald-600" : "text-primary";
  return (
    <section data-testid={tid}
             className="mb-4 rounded-2xl border border-border/60 bg-background p-5 shadow-neu-sm">
      <header className="mb-3 flex items-center justify-between gap-2" dir="rtl">
        <div className={`flex items-center gap-2 font-bold ${toneCls}`}>
          {Icon ? <Icon className="h-4.5 w-4.5" /> : null}
          <span className="text-sm">{title}</span>
        </div>
        {action}
      </header>
      <div dir="rtl">{children}</div>
    </section>
  );
};

// صف عرض ثنائي: تسمية + قيمة (قريبان في نفس السطر).
export const DetailRow = ({ label, value, tid }) => (
  <div className="flex items-baseline gap-2 py-1 text-xs" data-testid={tid}>
    <span className="text-muted-foreground">{label}:</span>
    <span className="font-bold text-foreground">{value}</span>
  </div>
);
